// src/services/notes.ts
// Service layer per il modulo Notes & Voice (bot Telegram + n8n agent backend).
//
// IMPORTANTE: api/axios.js ha baseURL con trailing slash, quindi tutti i path
// qui partono SENZA slash iniziale: 'api/notes/' (non '/api/notes/').
import api from '../api/axios';

// ----------------------------------------------------------------------------
// Tipi
// ----------------------------------------------------------------------------

export type NoteType = 'meeting' | 'note';

export interface NoteListItem {
  id: number | string;
  title: string;
  type: NoteType;
  created_at: string; // ISO 8601
}

export interface Note extends NoteListItem {
  /** Markdown body. Read-only nel client. */
  content: string;
  updated_at?: string;
}

export interface TelegramBotStatus {
  bound: boolean;
  bot_username?: string;
  /** true quando l'utente ha già mandato /start al bot. */
  claimed?: boolean;
  created_at?: string;
}

// ----------------------------------------------------------------------------
// Notes
// ----------------------------------------------------------------------------

/** GET /api/notes/ → lista note dell'utente, ordinate dal backend per created_at desc. */
export const listNotes = () => {
  return api.get<NoteListItem[]>('api/notes/');
};

/** GET /api/notes/{id}/ → dettaglio nota con markdown body. */
export const getNote = (id: number | string) => {
  return api.get<Note>(`api/notes/${id}/`);
};

// ----------------------------------------------------------------------------
// Telegram bot binding
// ----------------------------------------------------------------------------

/** GET /api/telegram/bots/me/ → stato del bot dell'utente corrente. */
export const getMyTelegramBot = () => {
  return api.get<TelegramBotStatus>('api/telegram/bots/me/');
};

/** POST /api/telegram/bots/ → crea binding fornendo il token di BotFather. */
export const bindTelegramBot = (token: string) => {
  return api.post<TelegramBotStatus>('api/telegram/bots/', { token });
};

/** DELETE /api/telegram/bots/me/ → rimuove il binding del bot. */
export const unbindTelegramBot = () => {
  return api.delete('api/telegram/bots/me/');
};
